import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    backgroundColor: '#EDEEF2',
    height: 60,
    color: '#0E1247',
    width: '100%',
    minWidth: 'unset',
    boxSizing: 'border-box',
    margin: 0,
    padding: '15px',
    border: 'none',
  },
}));
